/* eslint-disable */

/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form-main');
      this.optionSelectors = this.querySelectorAll('.option-selector');
      this.data = this.getProductData();
      this.variant = this.getSelectedVariant();

      this.updateAvailability();
      this.updateAddToCartButton();
      this.addEventListener('change', this.handleVariantChange.bind(this));
      this.updateRelateOption();
      if (this.variant.related_flag) {
        var relate_time = setInterval(() => {
          if (document.getElementById("related-option-container")) {
            clearInterval(relate_time);
            this.updateRelateOption();
          }
        }, 100);
      }
    }


    updateRelateOption() {
      
      if (!this.variant) {
        return
      }
      
      let productFormVariants = document.querySelector("variant-picker")
      let preRelateEles = productFormVariants.querySelectorAll(".related-option")
      
      preRelateEles.forEach(re_ele => {
        document.getElementById("related-option-container").append(re_ele)
      });
      let add_sku_list = [];
      let add_price_total = 0;
      let add_compare_price_total = 0;
      if (document.querySelectorAll(".related-product")) {
        let relateProductELes = document.querySelectorAll(".related-product")
        for (let i = 0; i < relateProductELes.length; i++) {
          const new_ele = relateProductELes[i];
          let add_sku_eles = new_ele.querySelectorAll("input:checked")
          for (let j = 0; j < add_sku_eles.length; j++) {
            let add_sku = add_sku_eles[j].labels[0].getAttribute("data-sku")
            let add_price = add_sku_eles[j].labels[0].getAttribute("data-price")
            let add_compare_price = add_sku_eles[j].labels[0].getAttribute("data-compare_at_price")
            add_price = add_price ? parseInt(add_price) : 0;
            add_compare_price = add_compare_price ? parseInt(add_compare_price) : add_price;
            add_price_total += add_price;
            add_compare_price_total += add_compare_price;
            if (!add_sku.includes("none")) {
              add_sku_list.push(add_sku)
            }
          }
        }
      }
      if (this.variant.related_flag) {
        let newRelateEles = document.querySelectorAll(`[data-id="${this.variant.id}"`)
        
        for (let i = 0; i < newRelateEles.length; i++) {
          const new_ele = newRelateEles[i];
          let nodeOrderNotes = productFormVariants.getElementsByClassName("order-note")
          if (nodeOrderNotes.length > 0) {    
            productFormVariants.insertBefore(new_ele, nodeOrderNotes[0])
          }else{
            productFormVariants.appendChild(new_ele)
          }
          if (new_ele.querySelector("input:checked") == null && new_ele.querySelector("input").getAttribute('type') !== "checkbox") {
            new_ele.querySelector("input").checked = true
            new_ele.querySelector(".product-form__selected-value").innerHTML = new_ele.querySelector("input").labels[0].title
          }
          

          let add_sku = new_ele.querySelector("input:checked").labels[0].getAttribute("data-sku")

          let checkList = null


          let add_price = new_ele.querySelector("input:checked").labels[0].getAttribute("data-price")
          let add_compare_price = new_ele.querySelector("input:checked").labels[0].getAttribute("data-compare_at_price")

          if (new_ele.querySelector("input").getAttribute('type') === "checkbox") {
            checkList = new_ele.querySelectorAll("input:checked");
            add_sku = []
            add_price = 0
            add_compare_price = 0
            for (let j = 0; j < checkList.length; j++) {
              if (checkList[j].labels[0].getAttribute("data-sku") == "none") {
                continue
              }
              add_sku.push(checkList[j].labels[0].getAttribute("data-sku"))
              add_price += parseInt(checkList[j].labels[0].getAttribute("data-price")) || 0;
              add_compare_price += parseInt(checkList[j].labels[0].getAttribute("data-compare_at_price")) || 0;
            }
          }

          if (new_ele.querySelector("input:checked").title == "None" && new_ele.querySelector("input").getAttribute('type') !== "checkbox") {
            continue
          }
          
          add_price = add_price ? parseInt(add_price) : 0;
          add_compare_price = add_compare_price ? parseInt(add_compare_price) : add_price;
          add_price_total += add_price;
          add_compare_price_total += add_compare_price;

          if (!add_sku.includes("none") ) {
            if (Array.isArray(add_sku)) {
              add_sku_list.push(...add_sku)
            }else{
              add_sku_list.push(add_sku)
            }
          }
        }
      }
      this.updatePrice(add_price_total, add_compare_price_total)
      this.updateSku(add_sku_list)
    }
    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      
      this.variant = null;

      // Get selected variant data (if variant exists).
      this.variant = this.getSelectedVariant();

      if (this.variant) {
        this.updateMedia();
        this.updateUrl(evt);
        this.updateVariantInput();
      }

      this.updateAddToCartButton();
      this.updateAvailability();
      this.updatePrice();
      this.updateWeight();
      this.updateBarcode();
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      VariantPicker.updateLabelText(evt);
      this.updateRelateOption();
      this.dispatchEvent(new CustomEvent('on:variant:change', {
        bubbles: true,
        detail: {
          form: this.productForm,
          variant: this.variant,
          product: this.data.product
        }
      }));
    }

    /**
     * Updates the "Add to Cart" button label and disabled state.
     */
    updateAddToCartButton() {
      this.productForm = this.section.querySelector('.js-product-form-main');
      if (!this.productForm) return;

      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
      let product_list = ['DW Tile','Dune','Kai Ming','Everstone']
      if (product_list.includes(this.addBtn.getAttribute("data-vendor"))) return;
      const variantAvailable = this.variant && this.variant.available;
      const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;
      this.addBtn.disabled = !variantAvailable;
      this.addBtn.textContent = variantAvailable
        ? this.addBtn.dataset.addToCartText
        : unavailableStr;
    }

    /**
     * Updates the availability status of an option.
     * @param {Element} optionEl - Option element.
     * @param {boolean} exists - Does this option lead to a variant that exists?
     * @param {boolean} available - Does this option lead to a variant that is available to buy?
     */
    static updateOptionAvailability(optionEl, exists, available) {
      const el = optionEl;
      const unavailableText = exists ? theme.strings.noStock : theme.strings.noVariant;
      el.classList.toggle('is-unavailable', !available);
      el.classList.toggle('is-nonexistent', !exists);

      if (optionEl.classList.contains('custom-select__option')) {
        const em = el.querySelector('em');

        if (em) {
          em.hidden = available;
        }

        if (!available) {
          if (em) {
            em.textContent = unavailableText;
          } else {
            el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${unavailableText}</em>`;
          }
        }
      } else if (!available) {
        el.nextElementSibling.title = unavailableText;
      } else {
        el.nextElementSibling.removeAttribute('title');
      }
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      let product_list = ['DW Tile','Dune','Kai Ming','Everstone']
      if (product_list.includes(this.dataset.vendor)) return;

      if (this.dataset.showAvailability === 'false') return;
      const { availabilityMethod } = this.dataset; // 'downward' or 'selection'
      let currVariant = this.variant;
      const selectedOptions = this.getSelectedOptions();

      if (!this.variant) {
        currVariant = { options: selectedOptions };
      }

      if (availabilityMethod === 'selection') {
        // Flag all options as unavailable
        this.querySelectorAll('.js-option').forEach((optionEl) => {
          VariantPicker.updateOptionAvailability(optionEl, false, false);
        });

        // Flag selector options as available or sold out, depending on the variant availability
        this.optionSelectors.forEach((selector, selectorIndex) => {
          this.data.product.variants.forEach((variant) => {
            let matchCount = 0;

            variant.options.forEach((option, optionIndex) => {
              if (option === currVariant.options[optionIndex] && optionIndex !== selectorIndex) {
                matchCount += 1;
              }
            });

            if (matchCount === currVariant.options.length - 1) {
              const options = selector.querySelectorAll('.js-option');
              const optionEl = Array.from(options).find((opt) => {
                if (selector.dataset.selectorType === 'dropdown') {
                  return opt.dataset.value === variant.options[selectorIndex];
                }
                return opt.value === variant.options[selectorIndex];
              });

              if (optionEl) {
                VariantPicker.updateOptionAvailability(optionEl, true, variant.available);
              }
            }
          });
        });
      } else {
        this.optionSelectors.forEach((selector, selectorIndex) => {
          const options = selector.querySelectorAll('.js-option:not([data-value=""])');
          options.forEach((option) => {
            const optionValue = selector.dataset.selectorType === 'dropdown' ? option.dataset.value : option.value;
            // any available variants with previous options and this one locked in?
            let variantsExist = false;
            let variantsAvailable = false;
            this.data.product.variants.forEach((v) => {
              let matches = 0;
              for (let i = 0; i < selectorIndex; i += 1) {
                if (v.options[i] === selectedOptions[i] || selectedOptions[i] === null) {
                  matches += 1;
                }
              }
              if (v.options[selectorIndex] === optionValue && matches === selectorIndex) {
                variantsExist = true;
                if (v.available) {
                  variantsAvailable = true;
                }
              }
            });
            VariantPicker.updateOptionAvailability(option, variantsExist, variantsAvailable);
          });
        });
      }
    }

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder = this.backorder || this.section.querySelector('.backorder');
      if (!this.backorder) return;

      let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];

        if (this.variant.inventory_management && inventory === 'none') {
          const backorderProdEl = this.backorder.querySelector('.backorder__product');
          const prodTitleEl = this.section.querySelector('.product-title');
          const variantTitle = this.variant.title.includes('Default')
            ? ''
            : ` - ${this.variant.title}`;

          backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          hideBackorder = false;
        }
      }

      this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the color option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      if (selector.dataset.selectorType === 'dropdown') return;
      if (selector.dataset.name === 'option-relate-extra_service') return;
      if (selector.dataset.name === 'option-relate-extra_treatments') return;

      const colorText = selector.querySelector('.js-color-text');
      
      if (!colorText) return;

      colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
    }

    /**
     * Updates the product media.
     */
    updateMedia() {
      if (!this.variant.featured_media) return;

      if (this.section.matches('quick-add-drawer')) {
        this.section.updateMedia(this.variant.featured_media.id);
      } else {
        this.mediaGallery = this.mediaGallery || this.section.querySelector('media-gallery');
        if (!this.mediaGallery) return;

        const variantMedia = this.mediaGallery.querySelector(
          `[data-media-id="${this.variant.featured_media.id}"]`
        );
        this.mediaGallery.setActiveMedia(variantMedia, true, true);
      }
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability =
        this.pickUpAvailability || this.section.querySelector('pickup-availability');
      if (!this.pickUpAvailability) return;

      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute('available');
        this.pickUpAvailability.innerHTML = '';
      }
    }

    formatAsMoney(amount, currency = 'USD', locale = 'en-US') {
      const formatter = new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currency
      });
      return formatter.format(amount);
    }
    /**
     * Updates the price.
     */
    updatePrice(add_price = 0, add_compare_price = 0) {
      this.price = this.price || this.section.querySelector('.product-info__price > .price');
      if (!this.price) return;

      if (this.variant) {

        if (this.data.template_suffix == "square-calculator") {
          let variant_id = this.variant.id;
          let box_size = this.data.formatted[variant_id].boxSize;
          let price = this.variant.price
          let pre_price = Math.round(price / 100 / box_size);

          let input = document.getElementById("square-input");
          let boxSize = document.getElementById("box-size");
          let checkbox = document.getElementById("wastage-checkbox");
          let boxQuantityElement = document.getElementById("box-quantity");
          let totalPriceElement = document.getElementById("total-price");
          let priceElement = document.getElementById("square-price");

          input.value = box_size;
           
          boxQuantityElement.innerHTML = 1;
          totalPriceElement.innerHTML = this.formatAsMoney(price / 100);
          priceElement.innerHTML = `${this.formatAsMoney(pre_price)} / m² = ${this.formatAsMoney(price / 100)} / Box`;
          priceElement.setAttribute("data-box-price", price);
          priceElement.setAttribute("data-box-size", box_size);
          if (checkbox) {
            checkbox.checked = false;
          }

        }else{
          const priceCurrentEl = this.price.querySelector('.price__current');
          const priceWasEl = this.price.querySelector('.price__was');
          const unitPriceEl = this.price.querySelector('.unit-price');
  
          // Update current price and original price if on sale.
          // priceCurrentEl.innerHTML = this.data.formatted[this.variant.id].price
          let cur_price = this.variant.price + add_price
          priceCurrentEl.innerHTML = this.formatAsMoney(cur_price / 100);
  
          if (this.variant.compare_at_price || add_compare_price > 0) {
            let cur_compare_price = this.variant.compare_at_price ? (this.variant.compare_at_price + add_compare_price): add_compare_price; 
  
            if (cur_compare_price > cur_price) {
              priceWasEl.innerHTML = this.formatAsMoney(cur_compare_price / 100);
            } else {
              priceWasEl.innerHTML = "";
            }
          }else{
            priceWasEl.innerHTML = "";
          }
  
          // Update unit price, if specified.
          if (this.variant.unit_price_measurement) {
            const valueEl = this.price.querySelector('.unit-price__price');
            const unitEl = this.price.querySelector('.unit-price__unit');
            const value = this.variant.unit_price_measurement.reference_value;
            const unit = this.variant.unit_price_measurement.reference_unit;
  
            valueEl.innerHTML = this.data.formatted[this.variant.id].unitPrice;
            unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
          }
  
          unitPriceEl.hidden = !this.variant.unit_price_measurement;
          this.price.classList.toggle(
            'price--on-sale',
            this.variant.compare_at_price > this.variant.price
          );
          this.price.classList.toggle('price--sold-out', !this.variant.available);

        }


      }

      this.price.querySelector('.price__default').hidden = !this.variant;
      this.price.querySelector('.price__no-variant').hidden = this.variant;
    }

    /**
     * Updates the weight.
     */
    updateWeight() {
      this.weights = this.weights || this.section.querySelectorAll('.product-info__weight');
      if (this.weights.length === 0) return;

      const weightAvailable = this.variant && this.variant.weight > 0;
      this.weights.forEach((weight) => {
        weight.textContent = weightAvailable ? this.data.formatted[this.variant.id].weight : '';
        weight.hidden = !weightAvailable;
      });
    }

    /**
     * Updates the Barcode.
     */
    updateBarcode() {
      this.barcodes = this.barcodes || this.section.querySelectorAll('.product-info__barcode-value');
      if (this.barcodes.length === 0) return;

      const barcodeAvailable = this.variant && this.variant.barcode;
      this.barcodes.forEach((barcode) => {
        barcode.textContent = barcodeAvailable ? this.variant.barcode : '';
        barcode.parentNode.hidden = !barcodeAvailable;
      });
    }

    /**
     * Updates the SKU.
     */
    updateSku(add_sku_list = []) {

      this.sku = this.sku || this.section.querySelector('.product-sku');
      if (!this.sku) return;

      const skuAvailable = this.variant && this.variant.sku;
      let sku_ele = ""
      sku_ele = `&nbsp;|&nbsp; <span>SKU:</span><span class="product-sku__value">${this.variant.sku}</span>`
      if (add_sku_list) {
        for (let index = 0; index < add_sku_list.length; index++) {
          sku_ele += `&nbsp;|&nbsp; <span>SKU:</span><span class="product-sku__value">${add_sku_list[index]}</span>`
        }
      }
      this.sku.innerHTML = skuAvailable ? sku_ele : '';
      this.sku.parentNode.hidden = !skuAvailable;
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.variant.id}`);
    }

    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms =
        this.forms || this.section.querySelectorAll('.js-product-form-main, .js-instalments-form');

      this.forms.forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        input.value = this.variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /**
     * Gets the selected option element from each selector.
     * @returns {Array}
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          selectedOptions.push(selector.querySelector('.custom-select__btn').textContent.trim());
        } else {
          let checkedEl = selector.querySelector('input:checked');
          if (checkedEl) {
            selectedOptions.push(checkedEl.value);
          }
        }
      });

      return selectedOptions;
    }

    /**
     * Gets the product data.
     * @returns {?object}
     */
    getProductData() {
      const dataEl = this.querySelector('[type="application/json"]');
      var jsonData = JSON.parse(dataEl.textContent);
      
      if (jsonData.hasOwnProperty("related_variant")) {
        for (let i = 0; i < jsonData.product.variants.length; i++) {
          jsonData.product.variants[i].related_flag = jsonData.related_variant[i]
        }
      }
      return jsonData;
    }

    /**
     * Get selected variant data.
     * @returns {?object} Variant object, or null if one is not selected.
     */
    getSelectedVariant() {
      const selectedOptions = this.getSelectedOptions();
      return this.data.product.variants.find(
        (v) => v.options.every((val, index) => val === selectedOptions[index])
      );
    }
  }

  customElements.define('variant-picker', VariantPicker);
}
